module.exports = __webpack_public_path__ + "static/img/bannerbg01.cdcf0dd2.png";